import React from 'react'
import { format } from '../format'
import { Location } from '../Models/workshops'

export interface LinkProps {
	url: string
	text: string
	opensInNewTab?: boolean
}

export function Link(props: LinkProps) {
	const anchorProps = {
		href: props.url, 
		target: props.opensInNewTab ? '_blank' : undefined
	}

	return <a {...anchorProps}>{props.text}</a>
} 

export const EmailLink = ({ email }: { email: string }) => <Link url={`mailto:${email}`} text={email} />

export const PhoneLink = ({ phoneNumber }: { phoneNumber: number | string}) => {
	const formattedNumber = format.phoneNumber(phoneNumber)
	return <Link url={`tel:${formattedNumber}`} text={formattedNumber} />
}

export const MapLink = ({ location }: { location: Location }) => {
	const queryString = new URLSearchParams({query: location.FullAddress}).toString()
	return <Link url={`https://www.google.com/maps/search/?api=1&${queryString}`} text={location.FullAddress} opensInNewTab={true} />
}